import React from "react";
import { Collapse, Box, useTheme, Grid2 as Grid } from "@mui/material";
import { MemorizedPreviousReceiveHeader } from "./PreviousReceiveHeader";
import { receiveStatus, closedStatusList } from "../../util/receiveStatus";
import { LargeActionButton } from "../Common/LargeActionButton";
import { PreviousReceiveProps } from "./types";
import {
	EditableManualReceiveLineItemTable,
	ReadonlyManualReceiveLineItemTable
} from "../Invoice/ManualReceiveLineItemTable";

export default function PreviousReceive(props: PreviousReceiveProps) {
	const {
		receive,
		onReceiveEditClick,
		onReceivedQuantityChange,
		onSetReceiveProperty,
		showDetailsOnly,
		isHardwareView,
		isLockedForReview,
		onCostChange,
		clearReceive,
		onHistoryClick,
		validateInvoiceNumber,
	} = props;
	const [open, setOpen] = React.useState(false);
	const theme = useTheme();

	return (
		<Box border={1} style={theme.fullWidth}>
			<Grid container>
				<Grid size={12}>
					<MemorizedPreviousReceiveHeader
						receive={receive}
						onReceiveEditClick={onReceiveEditClick}
						onSetReceiveProperty={onSetReceiveProperty}
						open={open}
						setOpen={setOpen}
						onHistoryClick={onHistoryClick}
						validateInvoiceNumber={validateInvoiceNumber}
					/>
				</Grid>
				<Grid size={12}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						{
							isLockedForReview && receive.status === receiveStatus.reviewing
							? (
								<EditableManualReceiveLineItemTable
									invoiceNumber={receive.invoiceNumber}
									lineItems={receive.receiveLineItems}
									isHardwareView={isHardwareView}
									showDetailsOnly={showDetailsOnly}
									onReceivedQuantityChange={onReceivedQuantityChange}
									onCostChange={onCostChange}
									showOverReceive={!closedStatusList.includes(receive.status)}
								/>
							) : (
								<ReadonlyManualReceiveLineItemTable
									invoiceNumber={receive.invoiceNumber}
									lineItems={receive.receiveLineItems}
									isHardwareView={isHardwareView}
									showDetailsOnly={showDetailsOnly}
									showOverReceive={!closedStatusList.includes(receive.status)}
								/>
							)
						}
						
					</Collapse>
				</Grid>
				<Grid size={12}>
					{(receive.status === receiveStatus.inProgress ||
						receive.status === receiveStatus.pendingReview ||
						receive.status === receiveStatus.reviewing ||
						(receive.isEdi && receive.status === receiveStatus.pendingFinalise)) && (
						<LargeActionButton
							onClick={() => clearReceive && clearReceive(receive.invoiceNumber)}
							disabled={false}
							children="Clear Receive"
						/>
					)}
				</Grid>
			</Grid>
		</Box>
	);
}
